<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * * The content below * * * * * * * * * * * -->
<!-- * * * * * * * * * * is only a placeholder * * * * * * * * * * -->
<!-- * * * * * * * * * * and can be replaced. * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * Delete the template below * * * * * * * * * * -->
<!-- * * * * * * * to get started with your project! * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->

<!-- <style>
  .dropbtn {
  color: grey;
  padding: 16px;
  font-size: 16px;
  border: none;
}

.dropdown {
  position: relative;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f1f1f1;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1;
  margin: 11px;
}

.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.dropdown-content a:hover {background-color: #ddd;}

.dropdown:hover .dropdown-content {display: block;}

.dropdown:hover .dropbtn {color: #3e8e41}
  @import url(https://fonts.googleapis.com/css?family=Lato);

*, *:before, *:after{
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  font-family: 'Lato', sans-serif;
}

/*| Navigation |*/

nav{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: #fff;
  box-shadow: 0 3px 10px -2px rgba(0,0,0,.1);
  border: 1px solid rgba(0,0,0,.1);
}
  nav ul{
    list-style: none;
    position: relative;
    float: right;
    margin-right: 100px;
    display: inline-table;
  }
    nav ul li{
      float: left;
      -webkit-transition: all .2s ease-in-out;
      -moz-transition: all .2s ease-in-out;
      transition: all .2s ease-in-out;
    }

    nav ul li:hover{background: rgba(0,0,0,.15);}
    nav ul li:hover > ul{display: block;}
    nav ul li{
      float: left;
      -webkit-transition: all .2s ease-in-out;
      -moz-transition: all .2s ease-in-out;
      transition: all .2s ease-in-out;
    }
      nav ul li a{
        display: block; 
        padding: 30px 20px;
        color: #222; 
        font-size: .9em;
        letter-spacing: 1px;
        text-decoration: none;
        text-transform: uppercase;
      }
      nav ul ul{
        display: none;
        background: #fff;
        position: absolute; 
        top: 100%;
        box-shadow: -3px 3px 10px -2px rgba(0,0,0,.1);
        border: 1px solid rgba(0,0,0,.1);
      }
        nav ul ul li{float: none; position: relative;}
          nav ul ul li a {
            padding: 15px 30px; 
            border-bottom: 1px solid rgba(0,0,0,.05);
          }
          nav ul ul ul {
            position: absolute; 
            left: 100%; 
            top:0;
          }	
  :host {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    font-size: 14px;
    color: #333;
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 8px 0;
  }

  p {
    margin: 0;
  }

  .spacer {
    flex: 0.9;
  }

  .toolbar {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 60px;
    display: flex;
    align-items: center;
    background-color: white;
    color: white;
    font-weight: 600;
  }

  .toolbar img {
    margin: 0 16px;
  }

  .toolbar #twitter-logo {
    height: 40px;
    margin: 0 16px;
  }

  .toolbar #twitter-logo:hover {
    opacity: 0.8;
  }

  .content {
    display: flex;
    margin: 82px auto 32px;
    padding: 0 16px;
    max-width: 960px;
    flex-direction: column;
    align-items: center;
  }

  svg.material-icons {
    height: 24px;
    width: auto;
  }

  svg.material-icons:not(:last-child) {
    margin-right: 8px;
  }

  .card svg.material-icons path {
    fill: #888;
  }

  .card-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 16px;
  }

  .card {
    border-radius: 4px;
    border: 1px solid #eee;
    background-color: #fafafa;
    height: 40px;
    width: 200px;
    margin: 0 8px 16px;
    padding: 16px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    transition: all 0.2s ease-in-out;
    line-height: 24px;
  }

  .card-container .card:not(:last-child) {
    margin-right: 0;
  }

  .card.card-small {
    height: 16px;
    width: 168px;
  }

  .card-container .card:not(.highlight-card) {
    cursor: pointer;
  }

  .card-container .card:not(.highlight-card):hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 17px rgba(0, 0, 0, 0.35);
  }

  .card-container .card:not(.highlight-card):hover .material-icons path {
    fill: rgb(105, 103, 103);
  }

  .card.highlight-card {
    background-color: #1976d2;
    color: white;
    font-weight: 600;
    border: none;
    width: auto;
    min-width: 30%;
    position: relative;
  }

  .card.card.highlight-card span {
    margin-left: 60px;
  }

  svg#rocket {
    width: 80px;
    position: absolute;
    left: -10px;
    top: -24px;
  }

  svg#rocket-smoke {
    height: calc(100vh - 95px);
    position: absolute;
    top: 10px;
    right: 180px;
    z-index: -10;
  }

  a,
  a:visited,
  a:hover {
    color: #1976d2;
    text-decoration: none;
  }

  a:hover {
    color: #125699;
  }

  .terminal {
    position: relative;
    width: 80%;
    max-width: 600px;
    border-radius: 6px;
    padding-top: 45px;
    margin-top: 8px;
    overflow: hidden;
    background-color: rgb(15, 15, 16);
  }

  .terminal::before {
    content: "\2022 \2022 \2022";
    position: absolute;
    top: 0;
    left: 0;
    height: 4px;
    background: rgb(58, 58, 58);
    color: #c2c3c4;
    width: 100%;
    font-size: 2rem;
    line-height: 0;
    padding: 14px 0;
    text-indent: 4px;
  }

  .terminal pre {
    font-family: SFMono-Regular,Consolas,Liberation Mono,Menlo,monospace;
    color: white;
    padding: 0 1rem 1rem;
    margin: 0;
  }

  .circle-link {
    height: 40px;
    width: 40px;
    border-radius: 40px;
    margin: 8px;
    background-color: white;
    border: 1px solid #eeeeee;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    transition: 1s ease-out;
  }

  .circle-link:hover {
    transform: translateY(-0.25rem);
    box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);
  }

  footer {
    margin-top: 8px;
    display: flex;
    align-items: center;
    line-height: 20px;
  }

  footer a {
    display: flex;
    align-items: center;
  }

  .github-star-badge {
    color: #24292e;
    display: flex;
    align-items: center;
    font-size: 12px;
    padding: 3px 10px;
    border: 1px solid rgba(27,31,35,.2);
    border-radius: 3px;
    background-image: linear-gradient(-180deg,#fafbfc,#eff3f6 90%);
    margin-left: 4px;
    font-weight: 600;
    font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol;
  }

  .github-star-badge:hover {
    background-image: linear-gradient(-180deg,#f0f3f6,#e6ebf1 90%);
    border-color: rgba(27,31,35,.35);
    background-position: -.5em;
  }

  .github-star-badge .material-icons {
    height: 16px;
    width: 16px;
    margin-right: 4px;
  }

  svg#clouds {
    position: fixed;
    bottom: -160px;
    left: -230px;
    z-index: -10;
    width: 1920px;
  }


  @media screen and (max-width: 767px) {

    .card-container > *:not(.circle-link) ,
    .terminal {
      width: 100%;
    }

    .card:not(.highlight-card) {
      height: 16px;
      margin: 8px 0;
    }

    .card.highlight-card span {
      margin-left: 72px;
    }

    svg#rocket-smoke {
      right: 120px;
      transform: rotate(-5deg);
    }
  }

  @media screen and (max-width: 575px) {
    svg#rocket-smoke {
      display: none;
      visibility: hidden;
    }
  }


  
</style> -->

<!-- Toolbar -->
<!-- <style>



  img{
    width: 114%;
    margin-left: -39px;
    margin-top: -14px;
    height: auto;
    z-index: 0;
    /* display:block;
   
    object-fit: cover;
      width: 100%;
    height: auto;
  
    z-index: 0; */
  }
  .hotspot{
    width: 28px;
    height: 28px;
    opacity: 0.7;
    background-color: #015a64;
    border-radius: 50%;
    position: absolute;
    animation: wave 1s infinite;
    cursor: pointer;
}
.mouse{
    right: 20%;
    bottom: 52%;
}
.vase{
    right: 14%;
    bottom: 51%;

}
.dust{
    right: 5%;
    bottom: 59%;
}
  </style> -->
  
  
  
  <!-- <map name="continents_map">
    <area shape="circle" coords="70,70,10" href="#north_america">
    <area shape="circle" coords="133,185,10" href="#south_america">
    <area shape="circle" coords="270,137,10" href="#africa">
    <area shape="circle" coords="292,44,10" href="#europe">
  </map> -->
<!--   
  <figure style="text-align:center;">
    <img usemap="#continents_map" src="https://firebasestorage.googleapis.com/v0/b/rising-theater-320112.appspot.com/o/original-b00411f2-66fb-433a-acd3-eef0ffe29f95.jpeg?alt=media&token=a31596e9-cd5a-40a3-85ec-35c65a578a92" width="600px" />
  </figure>

  <div  id="mousevalue"   class="hotspot mouse" text="Feed Hopper" >
    <i style="font-size: 16px;margin-left: 7px;margin-top: 6px;color: white;" class="fa">&#xf067;</i>
  </div>

  <div id="vasechange"  class="hotspot vase" text="Ergonomic Design">
    <i style="font-size: 16px;margin-left: 7px;margin-top: 6px;color: white;" class="fa">&#xf067;</i>
  </div>
  <div id="dust"   class="hotspot dust" text="Dust Suppression System">
    <i style="font-size: 16px;margin-left: 7px;margin-top: 6px;color: white;" class="fa">&#xf067;</i>
  </div>
  
   -->
   <style>
     .img-fluid {
    width: 80px;
    max-width: 45%;
    height: auto;
	
}
    /* button start */
    .btn {
  background-color: #649aa1;
  border: none;
  color: white;
  font-family: 'Titillium Web', sans-serif;
  padding: 6px 13px;
  font-size: 16px;
  cursor: pointer;
  border-radius: 27px;
}
  
  /* Darker background on mouse-over */
  .btn:hover {
    background-color: #F58220;
  }
  /* buttonend */
    /* popup start  */
  
  
  .popup
  {
    z-index: 10;
  /* width:450px; */
  height:180px;
  position:relative;
  margin:223px auto;
  display:block;
  text-align:center;
  -moz-background-clip: padding;
  -o-background-clip: padding;
  -webkit-background-clip: padding-box;
  background-clip: padding-box; /* prevents bg color from leaking outside the border */
  background-color: white; /* layer fill content */
  -moz-box-shadow: 0 0 10px rgba(0,0,0,.18); /* drop shadow */
  -webkit-box-shadow: 0 0 10px rgba(0,0,0,.18); /* drop shadow */
  -o-box-shadow: 0 0 10px rgba(0,0,0,.18); /* drop shadow */
  box-shadow: 0 0 10px rgba(0,0,0,.18); /* drop shadow */
  -webkit-transform-origin:top center;
  -moz-transform-origin:top center;
  -o-transform-origin:top center;
  transform-origin:top center;
  -webkit-animation: iconosani 1.2s forwards;
  animation: iconosani 1.2s forwards;
  -moz-animation: iconosani 1.2s forwards;
  -o-animation: iconosani 1.2s forwards;
  }
  
  @-webkit-keyframes iconosani {
      0% {
          -webkit-transform: perspective(800px) rotateX(-90deg);
          -moz-transform: perspective(800px) rotateX(-90deg);
          -o-transform: perspective(800px) rotateX(-90deg);
          opacity: 1;
      } 
      40% {
          -webkit-transform: perspective(800px) rotateX(30deg);
          -moz-transform: perspective(800px) rotateX(30deg);
          -o-transform: perspective(800px) rotateX(30deg);
          opacity: 1;
      }
      70% {
          -webkit-transform: perspective(800px) rotateX(-10deg);
          -moz-transform: perspective(800px) rotateX(-10deg);
          -o-transform: perspective(800px) rotateX(-10deg);
      }
      100% {
          -webkit-transform: perspective(800px) rotateX(0deg);
          -moz-transform: perspective(800px) rotateX(0deg);
          -o-transform: perspective(800px) rotateX(0deg);
          opacity: 1;
      }
  }
  
  
  .popScroll h1
  {
    height: 60px;
    position: relative;
    color: #fff;
    font: 25px/60px sans-serif;
    text-align: center;
    text-transform: lowercase;
    background: #3D79D0;
  }
  
  .subscribe-widget .email-form {
  font-size: 13px;
  color: #999999;
  padding-left: 6px;
  width: 270px;
  border: 1px solid #e0e0e0;
  padding: 5px 0 5px 5px;
  line-height: 25px;
  }
  
  .subscribe-widget .button {
  background: #3D79D0;
  padding: 6px 15px;
  color: #fff;
  border: none;
  line-height: 25px;
  margin-left:0;
  cursor:pointer;
  }
  
  /* input[type="submit"] {
  -webkit-appearance: button;
  -moz-appearance: button;
  -o-appearance: button;
  cursor: pointer;
  } */
  
  .popScroll p { padding: 1px 5px; 	font-family: 'Open Sans'; font-size: 17px; margin-bottom: 10px;  }
  
  
  #option { position: relative; }
  
  .boxi {
    display: inline-block;
    width: 169px;
    line-height: 42px;
    color: #fff;
    text-align: center;
    text-decoration: none;
    -webkit-transition: all 0.1s linear;
    -moz-transition: all 0.1s linear;
    -o-transition: all 0.1s linear;
    }
  
  #home { 
    background: #3D79D0;
    }
  
  #close { 
    background: #D21111;
    }
  
  .popScroll em {
    width: 42px;
    display: inline-block;
    position: relative;
    margin: 0 -20px;
    line-height: 42px;
    background: #fff;
    color: #777;
    text-align: center;
    border-radius: 50px;
    }
  
  #home:hover { background: #1852C7;  }
  #close:hover { background: #B30E0E; }
  
  
  body.overlay:after{
    content:'';
    width:100%;
    height:100%;
    top:0px; left:0px;
    z-index:0;
    opacity:.8;
  position:fixed; top:0; left:0; bottom:0; right:0;
    background:#000;
  }
  
  body.overlay{ /* Prevents scrolling */
    overflow:hidden;
    max-height:100%;
    max-width:100%;
  }
  
  
  .ribbon {
    position: absolute;
    z-index: 100;
    width: 100px;
    height: 100px;
    overflow: hidden;
  }
  
  .ribbon.top-left {
    top: -2.6px;
    left: -5px;
  }
  
  .ribbon.top-left.ribbon-primary > small {
    *zoom: 1;
    filter: progid:DXImageTransform.Microsoft.gradient(gradientType=0, startColorstr='#FF428BCA', endColorstr='#FF2A6496');
    background-image: -moz-linear-gradient(top, #428bca 0%, #2a6496 100%);
    background-image: -webkit-linear-gradient(top, #428bca 0%, #2a6496 100%);
    background-image: linear-gradient(to bottom, #3aa566 0%, #379347 100%);
    position: absolute;
    display: block;
    width: 100%;
    padding: 8px 10px;
    text-align: center;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 65%;
    color: white;
    background-color: #428bca;
    -moz-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    -moz-box-shadow: 0 3px 6px -3px rgba(0, 0, 0, 0.5);
    -webkit-box-shadow: 0 3px 6px -3px rgba(0, 0, 0, 0.5);
    box-shadow: 0 3px 6px -3px rgba(0, 0, 0, 0.5);
    top: 8px;
    left: -27px;
  }
  .ribbon.top-left.ribbon-primary > small:before, .ribbon.top-left.ribbon-primary > small:after {
    position: absolute;
    content: " ";
  }
  .ribbon.top-left.ribbon-primary > small:before {
    left: 0;
  }
  .ribbon.top-left.ribbon-primary > small:after {
    right: 0;
  }
  .ribbon.top-left.ribbon-primary > small:before, .ribbon.top-left.ribbon-primary > small:after {
    bottom: -3px;
    border-top: 3px solid #0e2132;
    border-left: 3px solid transparent;
    border-right: 3px solid transparent;
  }
  
  /* popup stop */
  
    /* @media screen and (-webkit-min-device-pixel-ratio:0) {
      input[type='range'] {
        overflow: hidden;
        width: 80px;
        -webkit-appearance: none;
        background-color: #9a905d;
      }
      
      input[type='range']::-webkit-slider-runnable-track {
        height: 10px;
        -webkit-appearance: none;
        color: #13bba4;
        margin-top: -1px;
      }
      
      input[type='range']::-webkit-slider-thumb {
        width: 10px;
        -webkit-appearance: none;
        height: 10px;
        cursor: ew-resize;
        background: #434343;
        box-shadow: -200px 0 0 200px black;
      }
  
  } */
  /** FF*/
  input[type="range"]::-moz-range-progress {
    background-color: #43e5f7; 
  }
  input[type="range"]::-moz-range-track {  
    background-color: #9a905d;
  }
  /* IE*/
  input[type="range"]::-ms-fill-lower {
    background-color: #43e5f7; 
  }
  input[type="range"]::-ms-fill-upper {  
    background-color: #9a905d;
  }
   @import url('https://fonts.googleapis.com/css?family=Roboto:400,500,700');
  *
  {
      -webkit-box-sizing: border-box;
              box-sizing: border-box;
      margin: 0;
      padding: 0;
  }
  
  
  
  h1 {
    text-align: center;
    font-family: Tahoma, Arial, sans-serif;
    color: #06D85F;
    margin: 80px 0;
  }
  
  
  
  a
  {
      text-decoration: none;
  }
  .product-card {
      width: 380px;
      position: relative;
      box-shadow: 0 2px 7px #dfdfdf;
      margin: 50px auto;
      background: #fafafa;
  }
  
  .badge {
      position: absolute;
      left: 0;
      top: 20px;
      text-transform: uppercase;
      font-size: 13px;
      font-weight: 700;
      background: red;
      color: #fff;
      padding: 3px 10px;
  }
  
  .product-tumb {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 300px;
      padding: 50px;
      background: #f0f0f0;
  }
  
  .product-tumb img {
      max-width: 100%;
      max-height: 100%;
  }
  
  .product-details {
      padding: 0px;
      color: white
  }
  
  .product-catagory {
      display: block;
      font-size: 16px;
      font-weight: 700;
      /* text-transform: uppercase; */
      color: white;
      margin-left: 150px;
      margin-bottom: 18px;
  }
  
  .product-details h4 a {
      font-weight: 500;
      display: block;
      margin-bottom: 18px;
      text-transform: uppercase;
      color: #363636;
      text-decoration: none;
      transition: 0.3s;
  }
  
  .product-details h4 a:hover {
      color: #fbb72c;
  }
  
  .product-details p {
      font-size: 15px;
      line-height: 22px;
      margin-bottom: 18px;
      color: #999;
  }
  
  .product-bottom-details {
      overflow: hidden;
      border-top: 1px solid #eee;
      padding-top: 20px;
  }
  
  .product-bottom-details div {
      float: left;
      width: 50%;
  }
  
  .product-price {
      font-size: 18px;
      color: #fbb72c;
      font-weight: 600;
  }
  
  .product-price small {
      font-size: 80%;
      font-weight: 400;
      text-decoration: line-through;
      display: inline-block;
      margin-right: 5px;
  }
  
  .product-links {
      text-align: right;
  }
  
  .product-links a {
      display: inline-block;
      margin-left: 5px;
      color: #e1e1e1;
      transition: 0.3s;
      font-size: 17px;
  }
  
  .product-links a:hover {
      color: #fbb72c;
  }
  .red{
    color:#F44336;
    font-size:22px;
    display:inline-block;
    margin: 0 5px;
  }
  @media screen and (max-width: 991px) {
    .wsk-cp-product{
      margin:40px auto;
    }
    .wsk-cp-product .wsk-cp-img{
    top:-40px;
  }
  .wsk-cp-product .wsk-cp-img img{
    box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);
  }
    .wsk-cp-product .wsk-cp-text .category > span{
    border-color:#ddd;
    box-shadow: none;
    padding: 11px 28px;
  }
  .wsk-cp-product .wsk-cp-text .category{
    margin-top: 0px;
  }
  a.buy-btn{
    border-color: #FF9800;
    background: #FF9800;
    color: #fff;
  }
  }
     .modal-demo .ui-modal {
      width: 37.5rem;
      /* for resize limits use min-width, min-height, max-width, max-height in css */
    }
    .modal-demo .ui-modal-overlay, .modal-demo .ui-modal {
      z-index: 10;
    }
    /* colors */
    :root {
      --dt-color-primary: #2b7639;
    }
    /* for IE */
    .ui-modal-header {
      background-color: #2b7639;
    }
  
  
  
  
      :host {
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
        font-size: 14px;
        color: #333;
        box-sizing: border-box;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
      }
    
      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        margin: 8px 0;
      }
    
      p {
        margin: 0;
      }
    
      .spacer {
        flex: 1;
      }
    
      .toolbar {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 60px;
        display: flex;
        align-items: center;
        background-color: #1976d2;
        color: white;
        font-weight: 600;
      }
    
      .toolbar img {
        margin: 0 16px;
      }
    
      .toolbar #twitter-logo {
        height: 40px;
        margin: 0 16px;
      }
    
      .toolbar #twitter-logo:hover {
        opacity: 0.8;
      }
    
      .content {
        display: flex;
        margin: 73px auto -13px;
        padding: 0 0px;
        max-width: 960px;
        flex-direction: column;
        align-items: center;
        margin-top: 17%;
      }
    
      svg.material-icons {
        height: 24px;
        width: auto;
      }
    
      svg.material-icons:not(:last-child) {
        margin-right: 8px;
      }
    
      .card svg.material-icons path {
        fill: #888;
      }
    
      .card-container {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-top: 16px;
      }
    
      .card {
        border-radius: 4px;
        border: 1px solid #eee;
        background-color: #fafafa;
        height: 40px;
        width: 200px;
        margin: 0 8px 16px;
        padding: 16px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        transition: all 0.2s ease-in-out;
        line-height: 24px;
      }
    
      .card-container .card:not(:last-child) {
        margin-right: 0;
      }
    
      .card.card-small {
        height: 16px;
        width: 168px;
      }
    
      .card-container .card:not(.highlight-card) {
        cursor: pointer;
      }
    
      .card-container .card:not(.highlight-card):hover {
        transform: translateY(-3px);
        box-shadow: 0 4px 17px rgba(0, 0, 0, 0.35);
      }
    
      .card-container .card:not(.highlight-card):hover .material-icons path {
        fill: rgb(105, 103, 103);
      }
    
      .card.highlight-card {
        background-color: #1976d2;
        color: white;
        font-weight: 600;
        border: none;
        width: auto;
        min-width: 30%;
        position: relative;
      }
    
      .card.card.highlight-card span {
        margin-left: 60px;
      }
    
      svg#rocket {
        width: 80px;
        position: absolute;
        left: -10px;
        top: -24px;
      }
    
      svg#rocket-smoke {
        height: calc(100vh - 95px);
        position: absolute;
        top: 10px;
        right: 180px;
        z-index: -10;
      }
    
      a,
      a:visited,
      a:hover {
        color: #1976d2;
        text-decoration: none;
      }
    
      a:hover {
        color: #125699;
      }
    
      .terminal {
        position: relative;
        width: 80%;
        max-width: 600px;
        border-radius: 6px;
        padding-top: 45px;
        margin-top: 8px;
        overflow: hidden;
        background-color: rgb(15, 15, 16);
      }
    
      .terminal::before {
        content: "\2022 \2022 \2022";
        position: absolute;
        top: 0;
        left: 0;
        height: 4px;
        background: rgb(58, 58, 58);
        color: #c2c3c4;
        width: 100%;
        font-size: 2rem;
        line-height: 0;
        padding: 14px 0;
        text-indent: 4px;
      }
    
      .terminal pre {
        font-family: SFMono-Regular,Consolas,Liberation Mono,Menlo,monospace;
        color: white;
        padding: 0 1rem 1rem;
        margin: 0;
      }
    
      .circle-link {
        height: 40px;
        width: 40px;
        border-radius: 40px;
        margin: 8px;
        background-color: white;
        border: 1px solid #eeeeee;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
        transition: 1s ease-out;
      }
    
      .circle-link:hover {
        transform: translateY(-0.25rem);
        box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);
      }
    
      footer {
        margin-top: 8px;
        display: flex;
        align-items: center;
        line-height: 20px;
      }
    
      footer a {
        display: flex;
        align-items: center;
      }
    
      .github-star-badge {
        color: #24292e;
        display: flex;
        align-items: center;
        font-size: 12px;
        padding: 3px 10px;
        border: 1px solid rgba(27,31,35,.2);
        border-radius: 3px;
        background-image: linear-gradient(-180deg,#fafbfc,#eff3f6 90%);
        margin-left: 4px;
        font-weight: 600;
        font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol;
      }
    
      .github-star-badge:hover {
        background-image: linear-gradient(-180deg,#f0f3f6,#e6ebf1 90%);
        border-color: rgba(27,31,35,.35);
        background-position: -.5em;
      }
    
      .github-star-badge .material-icons {
        height: 16px;
        width: 16px;
        margin-right: 4px;
      }
    
      svg#clouds {
        position: fixed;
        bottom: -160px;
        left: -230px;
        z-index: -10;
        width: 1920px;
      }
    
    
      /* Responsive Styles */
      @media screen and (max-width: 767px) {
    
        .card-container > *:not(.circle-link) ,
        .terminal {
          width: 100%;
        }
    
        .card:not(.highlight-card) {
          height: 16px;
          margin: 8px 0;
        }
    
        .card.highlight-card span {
          margin-left: 72px;
        }
    
        svg#rocket-smoke {
          right: 120px;
          transform: rotate(-5deg);
        }
      }
    
      @media screen and (max-width: 575px) {
        svg#rocket-smoke {
          display: none;
          visibility: hidden;
        }
      }
    
  
      /* id change */
      #lock{ display:none; }
       @media screen and (min-width: 320px) and (max-width: 767px) and (orientation:portrait ) {
       #lock{ display:block; }
      #con{ display:none; }
      }
       @media screen and (min-width: 320px) and (max-width: 767px) and (orientation: landscape) {
       #lock{ display:none; }
       #con{ display:block; }
      }
  </style>

   <style>
     .tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}

     body { margin: 0 !important; padding: 0 !important; width: 100% !important; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol' !important; }
.container { position: relative; overflow: hidden; height: 60vw; background-image:url("assets/img/homebg1.jpg"); background-size: cover; }
input { display: none; }
p { margin: 0; }
.button { color: white; font-weight: bold; font-size: 20px; background-color: #015a64; display: block; padding: 10px 16px; border-radius: 100%; cursor: pointer; animation: fadein .5s; animation: pulse 1.5s infinite; }
.content { background: white; padding: 1rem 1rem 2rem 1rem; text-align: center; display: none; margin: 10%; border-radius: 8px; box-shadow: 0 4px 2px -2px rgba(211,47,47,0); }
.cross { font-weight: bold; }
#b1 { position: absolute; left: 51%; top: 61%; }
#b2 { position: absolute; left: 28%; top: 76%; }
#b3 { position: absolute; left: 73%; top: 75%; }

#b4 { position: absolute; left: 86%; top: 45%; }
#b5 { position: absolute; left: 13%; top: 45%; }
#b6 { position: absolute; left: 1%; top: 3%; }
#b7 { position: absolute; left: 87%; top: 4%; }


#input1:checked ~ #content1,
#input2:checked ~ #content2,
#input3:checked ~ #content3 { display: block !important; animation: fadein .5s; }
input:checked ~ label .button { display: none !important; animation: fadeout .5s; }
.button:hover { color: #d32f2f; background: white; }
.cta { display: inline-block; background: #d32f2f; color: white; padding: 12px 24px; margin-top: 48px; border-radius: 24px; text-decoration: none; transition: all .3s ease; }
.cta:hover { text-decoration: underline !important; box-shadow: 0 0 0 6px rgba(211, 46, 46, 0.4); }
@keyframes fadein {
  from { opacity: 0; }
  to   { opacity: 1; }
}
@keyframes fadeout {
  from { opacity: 0; }
  to   { opacity: 1; }
}
@keyframes pulse {
  from { box-shadow: 0 0 0 0px rgba(229 227 227); }
  to { box-shadow: 0 0 0 15px rgba(0, 0, 0, 0); }
}

/* inspired by this article/tutorial > https://curated.email/hotspots-in-email */
   </style>
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"><div id="con">
  <div class="container">
    <!-- <input type="checkbox" class="input" id="input1" name="inputs">
    <input type="checkbox" class="input" id="input2" name="inputs">
    <input type="checkbox" class="input" id="input3" name="inputs"> -->
    <label for="input1" title="Track Mounted Jaw" (click)="track1()">
      <div id="b1" class="button" > <i class="fa fa-hand-o-up" style="font-size:36px;color: black;"></i>      </div>
    </label>
    <label for="input2" title="Track Mounted Cone"  (click)="track2()" >
      <div id="b2" class="button" ><i class="fa fa-hand-o-up" style="font-size:36px;color: black;"></i>
      </div>
    </label>
    <label for="input3"   title="Track Mounted Vertical Shaft Impactor" (click)="track3()" >
      <div id="b3" class="button"><i class="fa fa-hand-o-up" style="font-size:36px;color: black;"></i>
      </div>
    </label>
    <label for="input4" title="Track Mounted Screen [4 Deck]" (click)="track4()">
      <div id="b4" class="button"><i class="fa fa-hand-o-up" style="font-size:36px;color: black;"></i>
      </div>
    </label>
     <label for="input5" title="Track Mounted Screen [3 Deck]" (click)="track5()">
      <div id="b5" class="button"><i class="fa fa-hand-o-up" style="font-size:36px;color: black;"></i>
      </div>
    </label>
    <label for="input6">
      <div id="b6"><img _ngcontent-kgu-c147="" height="37px;" width="165px;" alt="Logo" src="/assets/img/logo1.png"></div>
    </label>
    <label for="input7">
      <div id="b7">    <button class="btn" (click)="backtoweb()">Back to website
        <!-- <i style="font-size: 16px;margin-left: 7px;margin-top: 6px;color: white;" class="fa">&#x2192;</i> -->
      </button></div>
    </label>




    <div id="content1" class="content">
      <div style="text-align: right;">
        <label for="input1" class="cross">X</label>
      </div>
      <h1>Content one</h1>
      <p class="bodyCopy">Additional content goes here.</p>
      <a href="#" class="cta">Find out more</a>
    </div>
    <div id="content2" class="content">
      <div style="text-align: right;">
        <label for="input2" class="cross">X</label>
      </div>
      <h1>Content two</h1>
      <p class="bodyCopy">Additional content goes here.</p>
      <a href="#" class="cta">Find out more</a>
    </div>
    <div id="content3" class="content">
      <div style="text-align: right;">
        <label for="input3" class="cross">X</label>
      </div>
      <h1>Content three</h1>
      <p class="bodyCopy">Additional content goes here.</p>
      <a href="#" class="cta">Find out more</a>
    </div>
  </div>
</div>

<div id="lock"  class="text-center" > 
  
 
  <div class="popScroll">
    <div class="popup">
      <span class="ribbon top-left ribbon-primary">
      <small>Notice!</small>
      </span> 
        <br>
        <br>
      <p>Kindly enable Auto Rotate option in your device and view in Landscape Mode.</p>
      <img src="assets/rotatedevice.gif" class="img-fluid" alt="">
   
    </div>
    </div>
    
  </div>
  





<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * * The content above * * * * * * * * * * * -->
<!-- * * * * * * * * * * is only a placeholder * * * * * * * * * * -->
<!-- * * * * * * * * * * and can be replaced. * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * End of Placeholder * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->



<router-outlet></router-outlet>


<!-- <footer class="footer">
  &nbsp;Copyrights 2021.<a href="https://www.propelind.com/" target="_blank" rel="noopener">Propel Industries.</a>
  All rights reserved
</footer> -->


